import {FormControl} from "@luciad/ria-sample-common/components/FormControl";
import {useMapContext} from "@luciad/ria-sample-common/hooks/useMapContext";
import {IToastContext, useToastContext} from "@luciad/ria-sample-common/hooks/useToast";
import {Map} from "@luciad/ria/view/Map";
import React, {ChangeEvent, FormEvent, PropsWithChildren, useState} from "react";
import {WizardPreviousNextButtons} from "./WizardPreviousNextButtons";

interface Props {
  onSubmit: (url: string, map: Map, toastContext: IToastContext) => void;
  onPrevious: () => void;
  defaultValue?: string;
  nextLabel?: string;
}

export const ConnectToURLPage = ({
                                   onSubmit,
                                   onPrevious,
                                   defaultValue,
                                   children
                                 }: PropsWithChildren<Props>) => {
  const {map} = useMapContext();
  const toastContext = useToastContext();
  const [url, setUrl] = useState<string>(defaultValue ?? "");

  const handleUrlChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setUrl(ev.target.value);
  }

  const handleSubmit = (ev?: FormEvent) => {
    if (ev) {
      ev.preventDefault();
    }
    onSubmit(url, map, toastContext);
  }

  return (
      <form onSubmit={handleSubmit}>
          <FormControl>
            <label htmlFor="url">URL</label>
            <input name="url" type="text" value={url} onChange={handleUrlChange}/>
          </FormControl>
          {children}
        <WizardPreviousNextButtons onPrevious={onPrevious} onNext={handleSubmit}/>
      </form>
  )
}